import React from "react";
import "./Cart.css";

const App = () => {
  return (
    <div className="container">
      <div id="whom-we-serve">
        <h2>Whom We Serve?</h2>
        <p>
          At Sawla Stones, our customers are as diverse as our range of Kota
          Stone. Here’s a glimpse of who benefits the most from our premium
          stone selection:
        </p>
      </div>

      <div className="cards-container">
        <div className="card" id="traders-card">
          <div className="card-header">📋</div>
          <h3>Traders</h3>
          <p>
            For traders and wholesalers partnering with Sawla Stones means
            trust and growth. With top-quality Kota Stone, timely deliveries,
            and a wide range, you can confidently expand your market and meet
            client needs.
          </p>
        </div>

        <div className="card" id="builders-card">
          <div className="card-header">👷</div>
          <h3>Builders</h3>
          <p>
            In the competitive construction world, quality is key. Sawla Stones
            offers premium Kota Stone with durability and timeless appeal,
            helping builders deliver lasting structures and boost their
            reputation.
          </p>
        </div>

        <div className="card" id="architects-card">
          <div className="card-header">🛠️</div>
          <h3>Architects</h3>
          <p>
            At Sawla Stones, we offer a wide range of designs, finishes, and
            colors, making us the top choice for architects and designers. Our
            Kota Stone varieties effortlessly bring creative visions to life.
          </p>
        </div>
      </div>
    </div>
  );
};

export default App;
